// removed by extract-text-webpack-plugin
module.exports = {"tableCell":"AgregarInventario__tableCell___14Olb"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/inventarios/programacion-mensual/AgregarInventario.css
// module id = 631
// module chunks = 0